
const estoqueGridConfig = {
  idField: "idEstoque",
  columns: [
    { header: "Código", field: "REFERENCIA" },
    { header: "Produto", field: "DESCRICAO" },
    { header: "Dt. Mov.", field: "DATA_MOVIMENTACAO" },
    { header: "Quantidade", field: "QUANTIDADE" }
  ]
};

export default estoqueGridConfig;